import { useSyncExternalStore } from 'react';
import { pluginRegistry } from './pluginRegistry';
import type { RouteObject } from 'react-router-dom';

export function usePluginRoutes(): RouteObject[] {
  return useSyncExternalStore(
    (listener) => pluginRegistry.subscribe(listener),
    () => pluginRegistry.getRoutes(),
    () => pluginRegistry.getRoutes()
  );
}
